var PHONE_LENGTH = 10;
function formatPhone(phone, code) {
    if (phone === void 0) { phone = ''; }
    if (code === void 0) { code = ''; }
    if (typeof phone !== 'string') {
        return '';
    }
    var phoneNumbers = phone.split('').reduce(function (acc, char) {
        if ((Boolean(+char) || char === '0') && !Number.isNaN(+char)) {
            return acc + char;
        }
        return acc;
    }, '');
    if (phoneNumbers.length === 0) {
        return '';
    }
    if (phoneNumbers.length < PHONE_LENGTH) {
        phoneNumbers += new Array(PHONE_LENGTH - phoneNumbers.length).fill(' ').join('');
    }
    if (phoneNumbers.length > PHONE_LENGTH) {
        return "+".concat(phoneNumbers);
    }
    return "".concat(code.length ? code : '', " (").concat(phoneNumbers[0] +
        phoneNumbers[1] +
        phoneNumbers[2], ") ").concat(phoneNumbers[3] + phoneNumbers[4] + phoneNumbers[5]).concat(phoneNumbers[6] !== ' ' ? '-' : '').concat(phoneNumbers[6] + phoneNumbers[7] + phoneNumbers[8] + phoneNumbers[9]).trim();
}
export default formatPhone;
//# sourceMappingURL=formatPhone.js.map